import {
  Component,
  OnInit,
  ViewEncapsulation,
  Output,
  Input,
  EventEmitter,
  HostListener,
} from "@angular/core";

import { MenuGeneric } from "src/app/models/menus/MenuGeneric";
import { SceneService } from "src/app/services/scene/scene.service";

@Component({
  selector: "app-menu-item",
  templateUrl: "./menu-item.component.html",
  styleUrls: ["./menu-item.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class MenuItemComponent implements OnInit {
  // @Input()
  // public item: MenuItem;

  //Yo y mis hnos
  @Input()
  public items: MenuGeneric[];

  @Input()
  public level: number;

  @Output()
  public onClick: EventEmitter<any>;

  public clicked = false;

  public showItems = false;
  public color;

  constructor(protected sceneService: SceneService) {
    this.onClick = new EventEmitter();
  }
  public innerWidth: any;
  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.color = "#e6e6e7";
    // if (this.level === 0) {
    //   //Negro
    //   this.color = "#343a40";
    // } else if (this.level === 1) {
    //   //Gris
    //   this.color = "#6c757d";
    // } else {
    //   this.color = "#7b838a";
    // }
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  // getRandomColor() {
  //   //[ngStyle]="{ background: getRandomColor() }"
  //   var color = Math.floor(0x1000000 * Math.random()).toString(16);
  //   return "#" + ("000000" + color).slice(-6);
  // }

  // buttonClick(child?) {
  //   if (!this.item.getItems()) {
  //     //Click - Soy item final
  //     console.log("Soy item final");
  //     this.onClick.emit(this.item);
  //     return;
  //   }
  //   if (child) {
  //     console.log("CHILD EMMITER", child.getName());
  //     this.item
  //       .getItems()
  //       .filter((currentItem) => !currentItem.parentOfChild(child))
  //       .forEach((currentChild) => currentChild.hideItems());

  //     //Propago el click de mi hijo
  //     this.onClick.emit(child);
  //     return;
  //   }
  //   //Click - No soy item final
  //   //this.showItems = !this.showItems;
  //   //Oculto/Muestro mis hijos
  //   console.log("No soy item final");
  //   this.item.toggleShowItems();
  //   this.onClick.emit(this.item);
  // }

  clickOnMe(item: MenuGeneric) {
    
    // if (item.getButton().canBeSelected()) {
    //Me clickeo/desclickeo
    let clicked = item.getButton().isClicked();
    item.toggleShowItems();
    if (!clicked || (clicked && item.getButton().canUnclickByItself())){
      item.getButton().toogle();
    }
    if (!clicked) {
      //Oculto los hijos de mis hermanos y desclickeo a mis hermanos
      if (
        item.getButton().isClicked() &&
        item.getButton().canBrothersUnclick()
      ) {
        this.items
          .filter((each) => each !== item)
          .filter((each) => each.getButton().canBrothersUnclick())
          .forEach((each) => {
            //Escondo hijos de mis hnos
            each.hideItems();
            // each.setClicked(false);
            each.getButton().setClicked(false);
            //Esto debería ser recursivo (hijos de mis hijos)
            each.getItems().forEach((element) => {
              element.hideItems();
              //element.setClicked(false);
            });
          });
      }
    }
    
   // item.click();
    this.sceneService.doAction(item);
    //}
    //propago evento
    //this.onClick.emit(item);
  }

  // childClick(child?) {
  //   this.onClick.emit(child);
  // }
  
}
